import type { ComposeAttachment, MailAttachmentMeta } from './mailAttachments'

export type MailFolder = 'INBOX' | 'SENT' | 'DRAFT' | 'TRASH' | 'SPAM'

export type MailGroupColor = 'primary' | 'success' | 'warning' | 'info' | 'destructive'

export type MailGroup = {
  id: string
  name: string
  colorToken: MailGroupColor
}

export type MailMessage = {
  id: string
  thread_id: string
  folder: MailFolder
  subject: string
  from: string
  from_name?: string
  to: string[]
  cc?: string[]
  bcc?: string[]
  snippet: string
  body_html: string
  is_read: boolean
  is_favorite: boolean
  group_ids: string[]
  created_at: string
  attachments?: MailAttachmentMeta[]
}

export type MailSettings = {
  signature_html: string
}

/** Sidebar view: a folder, favorites-only, or a user group filter. */
export type MailNavView =
  | { kind: 'folder'; folder: MailFolder }
  | { kind: 'favorites' }
  | { kind: 'group'; groupId: string }

export type ComposeMode = 'new' | 'reply' | 'replyAll' | 'forward' | 'draft'

export type ComposeState = {
  open: boolean
  /**
   * Yazma oturumu kimliği: pencere yalnız yeni bir mail açılınca yeniden kurulur. Otomatik taslak kaydı
   * draftId/mode'u değiştirir; bunlar anahtara girerse pencere yeniden kurulup yazılan metin kaybolur.
   */
  session: string
  mode: ComposeMode
  draftId?: string
  to: string
  cc: string
  bcc: string
  subject: string
  body: string
  replyToId?: string
  attachments: ComposeAttachment[]
}

export type { ComposeAttachment, MailAttachmentMeta }

export const GROUP_COLOR_CLASS: Record<MailGroupColor, string> = {
  primary: 'bg-primary/15 text-primary',
  success: 'bg-success/15 text-success',
  warning: 'bg-warning/15 text-warning',
  info: 'bg-info/15 text-info',
  destructive: 'bg-destructive/15 text-destructive',
}

export const GROUP_DOT_CLASS: Record<MailGroupColor, string> = {
  primary: 'bg-primary',
  success: 'bg-success',
  warning: 'bg-warning',
  info: 'bg-info',
  destructive: 'bg-destructive',
}

export const SIGNATURE_ATTR = 'data-mail-signature'
